<template>
    <div class="admin-transform-recipe">
        <a href="#" style="margin-right: 10px; display: inline-block" class="btn btn-secondary btn-sm" @click.prevent="openDialogTransform">Transformer</a>
        <el-dialog title="Transformer en ingrédient" :visible.sync="dialogueTransform" width="50%" :close-on-click-modal="false" :close-on-press-escape="false" @closed="closedModalDialog">
            <p>Transformer les {{ recipes.length }} recettes en ingrédients ?</p>
            <el-alert title="Si les ingrédients existe déjà. Vous pouvez soit l'ajouter en plus de l'existant ou écraser l'existant." type="warning"></el-alert>
            <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogueTransform = false">Annuler</el-button>
                    <el-button v-if="recipes.length" :loading="loadingTransform" @click.prevent="transformToIngredient('overide')"  type="warning">Écraser</el-button>
                    <el-button v-if="recipes.length" :loading="loadingTransform" @click.prevent="transformToIngredient('add')"  type="primary">Ajouter</el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "AdminTransformRecipe",
    data() {
        return {
            dialogueTransform: false,
            loadingTransform: false,
            transformStatus: {
                already_exists: false
            },
            recipesInput: []
        }
    },
    computed: {
        recipes(){
            var recipes = Array.from(this.recipesInput).map( v => v.value );
            return recipes
        }
    },
    methods: {
        openDialogTransform(){
            this.recipesInput = $('input[name="recipes[]"]:checked')
            this.dialogueTransform = true
        },
        transformToIngredient(mode)
        {
            if( this.recipes.length ) {
                this.loadingTransform = true
                axios.post('/pro/recipes/transform', {recipes: this.recipes, mode}).then((r)=>{

                }).catch(()=>{

                }).then(()=>{
                    window.location.reload()
                })
            }

        },
        closedModalDialog() {
            this.loadingTransform = false
        }
    }
}
</script>

<style scoped>

</style>
